/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Drop_Text_HereInputs */

const en_dialog_text_to_audio_drop_text_here = /** @type {(inputs: Dialog_Text_To_Audio_Drop_Text_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop text here`)
};

const es_dialog_text_to_audio_drop_text_here = /** @type {(inputs: Dialog_Text_To_Audio_Drop_Text_HereInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suelta texto aquí`)
};

/**
* | output |
* | --- |
* | "Drop text here" |
*
* @param {Dialog_Text_To_Audio_Drop_Text_HereInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_drop_text_here = /** @type {((inputs?: Dialog_Text_To_Audio_Drop_Text_HereInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Drop_Text_HereInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_drop_text_here(inputs)
	return en_dialog_text_to_audio_drop_text_here(inputs)
});